import { IEvent } from '@travelnest/typewriter';
import { combineReducers } from 'redux';

import { ICustomerFromSearch } from '../../../data/entities/customer';
import { IProperty } from '../../../data/entities/property';
import { IEntityActions } from '../../../data/store';
import { Actions as BookingActions } from '../../../entities/bookings/actions';
import { Actions as ViewActions } from './actions';
import bookings from './bookings/reducers';
import customerEdit from './customer/edit/reducers';
import customer from './customer/reducers';
import home from './home/reducers';
import pricingView from './pricing/view/reducers';
import propertyView from './property/view/reducers';

type Actions = ViewActions | IEntityActions | BookingActions;

export const customerSearchResults = (state = [] as ICustomerFromSearch[], action: Actions | ViewActions = {} as any) => {
	switch (action.type) {
		case 'CUSTOMER_SEARCH_RECEIVE':
			return action.payload.customers;
		case 'CUSTOMER_SEARCH_FAILURE':
		case 'CUSTOMER_SEARCH_REQUEST':
		case 'ADMIN_CLEAR_CUSTOMER_RESULTS':
			return [] as ICustomerFromSearch[];
		default:
			return state;
	}
};

export const propertySearchResults = (state = [] as IProperty[], action: ViewActions | IEntityActions = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_SEARCH_RECEIVE':
			return action.payload.properties;
		case 'PROPERTY_SEARCH_FAILURE':
		case 'PROPERTY_SEARCH_REQUEST':
		case 'ADMIN_CLEAR_PROPERTY_RESULTS':
			return [];
		default:
			return state;
	}
};

export const bookingSearchResults = (state = [] as IEvent[], action: ViewActions | IEntityActions | BookingActions = {} as any) => {
	switch (action.type) {
		case 'BOOKINGS_GET_BY_SEARCH_TEXT_RECEIVE':
			return action.payload;
		case 'BOOKINGS_GET_BY_SEARCH_TEXT_FAILURE':
		case 'BOOKINGS_GET_BY_SEARCH_TEXT_REQUEST':
		case 'ADMIN_CLEAR_BOOKING_RESULTS':
			return [];
		default:
			return state;
	}
};

export const isSearchingCustomers = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case 'CUSTOMER_SEARCH_RECEIVE':
		case 'CUSTOMER_SEARCH_FAILURE':
			return false;
		case 'CUSTOMER_SEARCH_REQUEST':
			return true;
		default:
			return state;
	}
};

export const isSearchingProperties = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_SEARCH_RECEIVE':
		case 'PROPERTY_SEARCH_FAILURE':
			return false;
		case 'PROPERTY_SEARCH_REQUEST':
			return true;
		default:
			return state;
	}
};

export const isSearchingBookings = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case 'BOOKINGS_GET_BY_SEARCH_TEXT_RECEIVE':
		case 'BOOKINGS_GET_BY_SEARCH_TEXT_FAILURE':
			return false;
		case 'BOOKINGS_GET_BY_SEARCH_TEXT_REQUEST':
			return true;
		default:
			return state;
	}
};

export interface IAdminPageState {
	home: ReturnType<typeof home>;
	bookings: ReturnType<typeof bookings>;
	customer: ReturnType<typeof customer>;
	customerEdit: ReturnType<typeof customerEdit>;
	isSearchingCustomers: ReturnType<typeof isSearchingCustomers>;
	isSearchingProperties: ReturnType<typeof isSearchingProperties>;
	isSearchingBookings: ReturnType<typeof isSearchingBookings>;
	customerSearchResults: ReturnType<typeof customerSearchResults>;
	propertySearchResults: ReturnType<typeof propertySearchResults>;
	bookingSearchResults: ReturnType<typeof bookingSearchResults>;
	propertyView: ReturnType<typeof propertyView>;
	pricingView: ReturnType<typeof pricingView>;
}

export default combineReducers<IAdminPageState>({
	home,
	bookings,
	customer,
	customerEdit,
	isSearchingCustomers,
	isSearchingProperties,
	isSearchingBookings,
	customerSearchResults,
	propertySearchResults,
	bookingSearchResults,
	propertyView,
	pricingView
});
